import { Theme } from '@mui/material'

const useStyles = {
  header: {
    width: '100%',
    position: 'absolute',
    left: 0,
  },
  container: (theme: Theme) => ({
    minHeight: 'calc(100vh - 150px - 16px)', // Adjust for 150px header + marginTop
    marginTop: `calc(${theme.spacing(2)} + 150px)`, // Add 150px for header
    [theme.breakpoints.up('md')]: {
      minHeight: 'calc(100vh - 103px - 103px - 150px)', // Adjust for margins on larger screens + 150px header
      marginTop: '150px', // Fixed 150px for header
    },
  }),
  form: {
    display: 'flex' as const,
    flexDirection: 'column' as const,
    flexGrow: 1,
  },
  spacer: {
    flexGrow: 1,
  },
  loginInput: (theme: Theme) => ({
    '& .MuiFormHelperText-root': {
      color: theme.palette.error.main,
    },
  }),
  pauseButtonContainer: (theme: Theme) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    gap: theme.spacing(2),
  }),
  confirmationAnimation: {
    width: '48px',
    height: '44px',
    justifySelf: 'center',
  },
  bulletList: {
    margin: 0,
    paddingLeft: '16px',
  },
  contentContainer: {
    gap: 2,
    flexDirection: 'column',
  },
  titleContainer: {
    gap: 1,
  },
  titleText: {
    fontWeight: '300',
  },
  formContentContainer: {
    gap: 2,
    flexDirection: 'column',
    flexGrow: '1',
  },
  formSection: {
    paddingBottom: 2,
    gap: 2,
  },
  sectionHeader: {
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: { xs: 1, sm: 2 },
  },
  sectionTitle: {
    fontWeight: '500',
    flex: 1,
  },
  detailsContainer: {
    flexDirection: 'column',
  },
  detailsTitle: {
    fontWeight: '500',
  },
  submitButtonContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingX: 3,
    paddingY: 3,
  },
  successContainer: {
    alignSelf: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingX: 2,
    gap: 3,
    marginTop: '-150px',
  },
  successTitle: {
    fontWeight: '300',
    textAlign: 'center',
  },
  successMessage: {
    textAlign: 'center',
  },
  successButtonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
}

export default useStyles
